


<template lang="jade">

	div.nav(
		v-if="$route.name !== 'trailer'"
	)

		div.nav-option(
			v-for="(film, index) in films"
			:key="index"
		)
			router-link.nav-link(
				:to="'/films/' + film.slug + '/trailer'"
				:class="{ 'router-link-active' : $route.params.filmID === film.slug }"
				@mouseenter.native="showPoster(film.slug, film.acf.credits)"
			) {{ film.title.rendered.toUpperCase() }}

			div.credits(
				v-html="film.acf.credits"
				v-if="$route.params.filmID === film.slug && $store.credits === true"
				style="display: none;"
			)

</template>



<script>



	const $cmp = {
		name : 'films-nav',
		components : {}
	}



	$cmp.data = function() {
		return {}
	}



	$cmp.computed = {}

	$cmp.computed.films = function() {

		let $this = this
		let $pages = $this.$store.pages

		if ($pages.films) {
			return $pages.films.children
		} else {
			return $pages
		}

	}



	$cmp.mounted = function() {
		var $this = this
	}



	$cmp.methods = {}

	$cmp.methods.showPoster = function(filmID, credits) {
		let $this = this
		//$this.$store.credits = true
		$this.$store.credits = credits.replace(/\/n/g, ' &mdash; ')
		if ($this.$route.params.filmID !== filmID) {
			$this.$router.push({ path : '/films/' + filmID })
		}
	}



	export default $cmp



</script>



<style lang="stylus" scoped>

	.nav
		position absolute
		display flex
		flex 1
		top 175px
		left 300px
		right 300px
		z-index 4

		@media(max-width 1439px)
			left 200px
			right 200px

		@media(max-width 1199px)
			left 100px
			right 100px

		@media(max-width 1023px)
			display none

	.nav-option
		flex 1
		max-width 25%
		color #FFFFFF
		text-align center

	.nav-link
		letter-spacing 1px
		line-height 160%
		color #FFFFFF
		padding-bottom 2px
		cursor pointer

	.nav-link:hover,
	.nav-link.router-link-active
		border-bottom 1px solid #FFFFFF

	.credits
		padding-top 30px
		font-size 10px
		letter-spacing 1px
		text-transform uppercase


</style>



// WEBPACK FOOTER //
// src/components/home/nav.vue